export default __webpack_public_path__ + "static/media/46.c51550dc.svg";